import type { NavigateFunction } from "react-router-dom";
import { signOut } from "@/hooks/useAuth";

/** Sign out of the shared demo account and return to the marketing landing page. */
export async function leaveDemoApp(navigate: NavigateFunction): Promise<void> {
  await signOut();
  navigate("/", { replace: true });
}
